export class File {
  Id = 0;
  Filename = '';
  Title = '';
  RefId = 0;
  IsPublic = false;
  Url = '';
}
